import { PaletteUtils } from '@shared/utils';
import { ColorsEnum, Icon, Text } from '@shared/widgets';
import ChevronIcon from '@assets/icons/chevron.svg';

interface IManagerItemProps {
  letter: string;
  name: string;
}

export const UserItem = (props: IManagerItemProps) => {
  return (
    <div className='w-full'>
      <div className='flex items-center bg-white dark:bg-soft-black p-3 pl-6 rounded bg-ice-bg transition-colors justify-between relative hover:bg-transparent focus:bg-transparent'>
        <div className='absolute left-0 top-0 w-full h-full z-2 rounded' />
        <div className='flex items-center min-w-0 flex-shrink'>
          <div className='mr-3 bg-primary flex items-center justify-center rounded-full w-12 h-12 overflow-hidden'>
            <div className='w-full h-full bg-accent flex items-center justify-center'>
              <Text weight='medium' size='2xl' color={PaletteUtils.isVcfcPalette ? ColorsEnum.White : ColorsEnum.Black}>
                {props.letter}
              </Text>
            </div>
          </div>
          <div className='flex-1 min-w-0'>
            <Text className='line-clamp-1' weight='medium' size='lg'>
              {props.name}
            </Text>
          </div>
        </div>
        <div className='flex items-center justify-center w-6 h-6 ml-2 text-slate-60'>
          <Icon icon={<ChevronIcon />} className='rotate-180' />
        </div>
      </div>
    </div>
  );
};
